import deltas from "../actions/deltas";
import createGridReducer, {SORT_ASC} from "../helpers/createGridReducer";
import {allColumns} from "../../components/organisms/enrolments/CoursesSection";
import {GRID_FILTER_TYPE_DATE} from "../../components/molecules/GridFilter";

const {
    SET_COURSES_GRID_DATA,
    ADD_VALUE_TO_COURSES_GRID_TEXT_FILTER,
    REMOVE_VALUE_FROM_COURSES_GRID_TEXT_FILTER,
    CLEAR_COURSES_GRID_TEXT_FILTER,
    CYCLE_COURSES_GRID_COLUMN_SORT_STATE,
    SET_COURSES_GRID_DATE_FILTER,
    CLEAR_COURSES_GRID_DATE_FILTER,
    RESET_COURSES_GRID_FILTER_AND_SORT,
    HIDE_COURSES_GRID_COLUMN,
    SHOW_COURSES_GRID_COLUMN,
    SHOW_ALL_COURSES_GRID_COLUMNS,
} = deltas.actionTypes;

export const dateColumns = allColumns.filter(col => col.gridFilterType === GRID_FILTER_TYPE_DATE).map(col => col.accessor);

const initialSorters = [
    {
        column: 'name',
        direction: SORT_ASC,
    },
];

const initialColumnsToHide = [
    'regionNames',
];

const initialFilters = {
    isActive: ['Yes'],
};

export default createGridReducer(
    [],
    initialSorters,
    initialColumnsToHide,
    dateColumns,
    SET_COURSES_GRID_DATA,
    ADD_VALUE_TO_COURSES_GRID_TEXT_FILTER,
    REMOVE_VALUE_FROM_COURSES_GRID_TEXT_FILTER,
    CLEAR_COURSES_GRID_TEXT_FILTER,
    CYCLE_COURSES_GRID_COLUMN_SORT_STATE,
    SET_COURSES_GRID_DATE_FILTER,
    CLEAR_COURSES_GRID_DATE_FILTER,
    RESET_COURSES_GRID_FILTER_AND_SORT,
    HIDE_COURSES_GRID_COLUMN,
    SHOW_COURSES_GRID_COLUMN,
    null, // setCurrentPage - no pagination, all course data is already loaded
    null, // setFuzzySearch - not used, no fuzzy-search columns on this grid
    SHOW_ALL_COURSES_GRID_COLUMNS,
    null, // setRowSelected - read-only grid, no row selection
    null, // unsetRowSelected
    null, // clearRowsSelected
    null, // setAllVisibleRowsSelected
    false, // backendSorted - all course data is already loaded, no separate paginated call needed
    initialFilters,
);
